// eslint-disable-next-line @typescript-eslint/no-use-before-define
import type * as React from 'react';
import { GatsbyImage, type IGatsbyImageData } from 'gatsby-plugin-image';

type ImageProps = {
  image: IGatsbyImageData;
  alt: string;
};

export const Image: React.FC<ImageProps> = ({ image, alt }) => {
  return (
    <div style={{ width: '100%', height: 'auto', marginBottom: '1.45rem' }}>
      <GatsbyImage image={image} alt={alt} objectFit="contain" />
    </div>
  );
};
